export const CHECK_DOMAIN_REQUEST = 'CHECK_DOMAIN_REQUEST'
export const CHECK_DOMAIN_SUCCESS = 'CHECK_DOMAIN_SUCCESS'
export const CHECK_DOMAIN_FAILURE = 'CHECK_DOMAIN_FAILURE'
export const CHECK_DOMAIN_UPDATE = 'CHECK_DOMAIN_UPDATE'

